import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {stringToRange} from 'web-app/react/components/form-elements/containers/range-picker/helpers';

import * as Actions from './actions';
import * as Api from './api';

const fetchReport = action$ =>
    action$
        .ofType(Actions.fetchReport.type, Actions.fetchInitialReport.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            const formData = payload.formData;
            const {lower, upper} = stringToRange(formData.age);

            return Api.fetchPublicFundingReport(
                payload.institutionId,
                formData.from,
                formData.to,
                formData.filter,
                formData.fundingTypes,
                lower,
                upper,
            )
                .map(({table, csv, fundingLoop}) => Actions.fetchReportSuccess.action(table, csv, fundingLoop))
                .catch(e => Observable.of(Actions.fetchReportFailed.action(e)));
        });

const changeFundingTypeForPlan = action$ =>
    action$.ofType(Actions.changeFundingTypeForPlan.type).mergeMap(({payload}) =>
        Api.updatePlanFundingTypes(payload.planId, payload.newFundingTypes)
            .map(() => Actions.changeFundingTypeForPlanSuccess.action())
            .catch(e => Observable.of(Actions.changeFundingTypeForPlanFailed.action(e))),
    );

export default combineEpics(fetchReport, changeFundingTypeForPlan);
